import './nav.css'
import { ChartNoAxesColumnIncreasing, Settings } from 'lucide-react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faGear } from "@fortawesome/free-solid-svg-icons";
import '../App.css'
import { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import MessageModal from '../Pages/messageModal';
import { useDispatch, useSelector } from 'react-redux';
import { changeEnergy, checkDuplicateLogins, checkIframBtn, checkJackpot } from '../store';
import { changeNum, changeUnits, handleVibration } from '../Pages/common/function';
import axios from 'axios';
import { useTranslation } from "react-i18next";

import useWindowSize from '../hook/useWindowSize'

function Header() {
    const { t } = useTranslation();

    let gold = useSelector((state) => { return state.gold.value })
    let myData = useSelector((state) => { return state.myData })
    let JWT = useSelector((state) => { return state.JWT.value })
    let haptic = useSelector((state) => { return state.haptic.value })
    let navigate = useNavigate()
    let dispatch = useDispatch()

    const { Rwidth, Rheight } = useWindowSize();
    const [adsHeightState, setAdsHeightState] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            if (location.pathname == "/") {
                const windowHeight = window.innerHeight;

                if (windowHeight <= 580) {
                    setAdsHeightState(1)
                } else if (windowHeight <= 650) {
                    setAdsHeightState(2)
                } else if (windowHeight <= 720) {
                    setAdsHeightState(3)
                } else {
                    setAdsHeightState(0)
                }
            } else {
                setAdsHeightState(0)
            }
        };

        handleResize();
        
    }, [Rheight]);

    let energy = useSelector((state) => { return state.energy.value })
    let limitUpgradeValue = useSelector((state) => { return state.limitUpgradeValue.value })
    let PlusEnergy = useSelector((state) => { return state.PlusEnergy })

    const intervalRef = useRef(null);

    useEffect(() => {
        if (PlusEnergy?.energy && PlusEnergy?.energyCycle) {
            if (!intervalRef.current && energy < limitUpgradeValue) {
                intervalRef.current = setInterval(() => {
                    dispatch(changeEnergy(energy + Number(PlusEnergy?.energy ?? 0)));
                }, Number(PlusEnergy?.energyCycle ?? 0));
            }

            if (energy >= limitUpgradeValue) {
                clearInterval(intervalRef.current);
                intervalRef.current = null; // 타이머 참조 초기화
            }

            return () => {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            };
        }
    }, [energy, limitUpgradeValue, PlusEnergy]);

    useEffect(() => {
        let intervalId;

        if (JWT?.length > 0) {
            fetchJackpotData(); // 초기 데이터 요청

            // 10초마다 fetchJackpotData 호출
            intervalId = setInterval(() => fetchJackpotData(), 10 * 1000);
        }

        // 컴포넌트 언마운트 시 또는 JWT가 변경될 때 인터벌 정리
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [JWT]); // JWT 변경 시에도 작동

    // 잭팟 시간 및 확율 확인
    const fetchJackpotData = async () => {
        await axios.get(process.env.REACT_APP_API + `/api/jackpot/slot`, {
            headers: {
                Authorization: `Bearer ${JWT}`,
            }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                dispatch(checkJackpot(tmp?.data ?? []))
            } else {
                dispatch(checkJackpot([]))
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const onClickBtn = (e) => {
        if (haptic) handleVibration(1);
        navigate(e)
    }

    return (
        <div className='header'>
            {
                adsHeightState === 2 || adsHeightState === 0
                    ?
                    <div className='header1'>
                        <div className='header1-backgroud'>
                            <img src='/img/default_cat_short.png' style={{ pointerEvents: "none" }} />
                        </div>
                        <div>{myData?.user_name ?? ""} ({myData?.id ?? ""})</div>
                    </div>
                    :
                    ""
            }
            <div className='header2'>
                {/* <div className='header2-1'>
                    <div className='header2-1-2' style={{ paddingTop: "2px" }}>
                        <div className='header2-1-2-2 fontNumber' style={{ width: "50%" }}>
                            <img src='/newImg/icon_main_diamond.png' style={{ pointerEvents: "none", width: "26px" }} />
                            <div style={{ display: 'flex', alignItems: "center" }}>
                                <span>{changeUnits(gold)}</span>
                            </div>
                        </div>
                        <div className='header2-1-2-2 fontNumber' style={{ width: "50%" }}>
                            <img src='/newImg/icon_main_jackpot(new).png' style={{ pointerEvents: "none", width: "24px" }} />
                            <div style={{ display: 'flex', alignItems: "center" }}>
                                <span>{changeUnits(jackpotSum)}</span>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className='header2-1'>
                    <div className='header2-1-2' style={{ paddingTop: "2px" }}>
                        <div className='header2-1-2-2 fontNumber' style={{ width: "50%", paddingLeft: '7px' }}>
                            <img src='/newImg/icon_main_diamond.png' style={{ pointerEvents: "none", width: "26px" }} />
                            <div style={{ display: 'flex', alignItems: "center" }}>
                                <span>{changeNum(gold)}</span>
                            </div>
                        </div>
                        <div style={{ padding: "5px 7px", borderLeft: "1px solid #43433b" }} onClick={() => onClickBtn('/setting')}>
                            <FontAwesomeIcon icon={faGear} fontSize={16} />
                        </div>
                    </div>
                </div>
                <div className='header2-2'>
                    <div className='header2-2-1' onClick={() => navigate('/memories')}>
                        <img src='/newImg/icon_main_heart.png' style={{ pointerEvents: "none", width: "32px" }} />
                        <div>{t('header_0')}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;